import Service from "../../AuthService";

const InvoicePayoffOther = {
    getInvoicePayoffOther(page){
        return Service.get("/invoice-payoff-other?page="+page);
    },
    showInvoicePayoffOther(id){
        return Service.get("/invoice-payoff-other/"+id);
    },
    createInvoicePayoffOther(data) {
        return Service.post("/invoice-payoff-other",data)
    },
    updateInvoicePayoffOther(id,data){
        return Service.put("/invoice-payoff-other/"+id,data);
    },
    deleteInvoicePayoffOther(id){
        return Service.delete("/invoice-payoff-other/"+id);
    },
    searchInvoicePayoffOther(data){
        return Service.post("/invoice_payoff_other_search",data)
    },
    printInvoicePayoffOther(id,user){
        return Service.get(`/payoff-other-pdf/${id}?user=${user}`);
    }
};

export default InvoicePayoffOther
